import gql from 'graphql-tag';

const clientWorkspaceStatsQuery = gql`
  query ClientWorkspaceStats($company: MongoID, $managerId: MongoID, $sourceType: String, $productId: String) {
    clientWorkspaceStatsQuery(
      company: $company
      managerId: $managerId
      sourceType: $sourceType
      productId: $productId
    ) {
      totalClients
      signedForTrial
      firstLessonCompleted
      paid
      revenue
    }
  }
`;
export default clientWorkspaceStatsQuery;
